import {
  useLazyGetCatalogOrdersQuery,
  useLazyGetCatalogsQuery,
  useLazyGetItemsQuery,
  useLazyGetSingleItemQuery,
} from 'core/catalog/CatalogService';
import { useLazyGetRestaurantListQuery } from 'core/restaurant/RestaurantService';
import {
  useCreateShippingCostMutation,
  useLazyGetShippingCostListQuery,
  useLazyGetShippingCostQuery,
  useUpdateShippingCostMutation,
} from 'core/shippingCost/ShippingCostService';
import { useEffect, useRef, useState } from 'react';
import { FormattedMessage, injectIntl, useIntl } from 'react-intl';
import { useAppDispatch, useAppSelector } from 'utilities/redux';
import { Form } from '@ant-design/compatible';
import { compose } from 'react-recompose';
import * as dayjs from 'dayjs';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';
import { convertToDayJsTime, getDayPart } from 'utilities/transformDateTime';
import toast from 'components/Basic/Toast';
import placeHolderImg from 'assets/img/placeholder.svg';
import { Add, Delete } from '@material-ui/icons';

import { useHistory } from 'react-router-dom';
import { Button, TimePicker, Input, Select, Tabs, Divider, Spin, Checkbox } from 'antd';
import { setRestaurantList } from 'core/restaurant/RestaurantSlice';
import { setShippingCost } from 'core/shippingCost/ShippingCostSlice';
import ContentHeader from '../ContentHeader';
import { getCurrency, getProductInfo } from 'utilities/common';
import { setShippingCostList } from 'core/shippingCost/ShippingCostSlice';
import debounce from 'lodash/debounce';
import { ClearOutlined } from '@ant-design/icons';

const INITIAL_SHIPPING_COST_ITEM = { restaurantIds: [], productId: null, priority: null };

const { TabPane } = Tabs;

const { Option } = Select;
dayjs.extend(utc);
dayjs.extend(timezone);

const ShippingCostNew = props => {
  const { match, form } = props;
  const intl = useIntl();
  const dispatch = useAppDispatch();

  const isMounted = useRef(false);

  const history = useHistory();

  const { getFieldDecorator } = form;

  const { params } = match;

  const [state, setState] = useState({
    id: params.id,
    catalogWithOrders: [],
  });

  const [errorMap, setErrorMap] = useState({});

  const [isCreateShippingCost, setCreateShippingCost] = useState(true);

  const [isAllSelected, setIsAllSelected] = useState(false);

  const [getShippingCostList] = useLazyGetShippingCostListQuery();
  const [createShippingCost] = useCreateShippingCostMutation();
  const [updateShippingCost] = useUpdateShippingCostMutation();
  const [getShippingCost] = useLazyGetShippingCostQuery();

  const [getRestaurantList] = useLazyGetRestaurantListQuery();

  const [getCatalogs] = useLazyGetCatalogsQuery();

  const [getCatalogOrder] = useLazyGetCatalogOrdersQuery();

  const { list } = useAppSelector(state => state.shippingCostReducer);

  const { list: restaurantList } = useAppSelector(state => state.restaurantReducer);

  const [getItemsList] = useLazyGetItemsQuery();

  const [getSingleItem] = useLazyGetSingleItemQuery();

  const getProduct = data => {
    return getProductInfo(data, [], []);
  };

  const { shippingCost: shippingCostInfo } = useAppSelector(state => state.shippingCostReducer);

  const generateKey = () => Date.now().toString() + Math.random().toString(36).substr(2, 9);

  const [restaurantShippingCost, setRestaurantShippingCost] = useState([
    { restaurantIds: [], productId: null, priority: null, key: '1' },
  ]);
  const items = [
    {
      label: intl.formatMessage({ id: 'Product' }) + ' 1',
      key: '1',
      children: intl.formatMessage({ id: 'Add item details' }),
    },
  ];
  const [tabItem, setTabItem] = useState(items);
  const [activeKey, setActiveKey] = useState(items[0].key);

  const priorityState = [
    { value: '1', label: ' 1' },
    { value: '2', label: ' 2' },
    { value: '3', label: ' 3' },
    { value: '4', label: ' 4' },
    { value: '5', label: ' 5' },
  ];

  const [options, setOptions] = useState([]);
  const [loading, setLoading] = useState(false);

  const handleAppendTab = (label = 'Item') => {
    setOptions([]);
    const newKey = generateKey();

    setTabItem(prev => {
      if (prev.length >= 5) return prev;
      const newPanes = [...prev, { label: '', key: newKey, children: intl.formatMessage({ id: 'Add item details' }) }];

      const reIndexedPanes = newPanes.map((pane, index) => ({
        ...pane,
        label: `${intl.formatMessage({ id: 'Product' })} ${index + 1}`,
      }));

      setActiveKey(newKey);
      return reIndexedPanes;
    });

    setRestaurantShippingCost(prev => {
      if (prev.length >= 5) return prev;
      return [...prev, { restaurantIds: [], productId: null, priority: null, key: newKey }];
    });
  };

  const handleRemoveTab = key => {
    if (tabItem.length <= 1) return;

    let newActiveKey = activeKey;

    setTabItem(prev => {
      const newPanes = prev.filter(item => item.key !== key);
      if (newActiveKey === key) {
        const lastItem = newPanes[newPanes.length - 1];
        newActiveKey = lastItem ? lastItem.key : '';
      }
      setActiveKey(newActiveKey);

      return newPanes.map((pane, index) => ({
        ...pane,
        label: `${intl.formatMessage({ id: 'Product' })} ${index + 1}`,
      }));
    });

    setRestaurantShippingCost(prev => {
      return prev.filter(item => item.key !== key);
    });
  };

  const onChangeTab = newActiveKey => {
    setActiveKey(newActiveKey);
  };

  const handleSearchRestaurant = e => {
    if (e.length == 0) {
      getRestaurantListData();
    } else {
      handleOnChangeRestaurants(e);
    }
  };

  const handleAllSelectedRestaurant = checked => {
    setIsAllSelected(checked);
    let restaurantIds = [];
    if (checked) {
      restaurantIds = restaurantList?.rows?.map(r => r.id) || [];
    } else {
      if (params.id) {
        restaurantIds = shippingCostInfo?.RestaurantShippingCost?.[0]?.restaurantIds || [];
      } else {
        restaurantIds = [];
      }
    }
    form.setFieldsValue({ restaurant: restaurantIds });
    setRestaurantShippingCost(prev => {
      if (prev.length === 0) return prev;
      return [{ ...prev[0], restaurantIds }, ...prev.slice(1)];
    });
  };

  const clearRestaurant = () => {
    form.setFieldsValue({ restaurant: [] });
    setIsAllSelected(false);
    setRestaurantShippingCost(prev => {
      if (prev.length === 0) return prev;
      return [{ ...prev[0], restaurantIds: [] }, ...prev.slice(1)];
    });
  };

  const handleOnChangeRestaurants = async values => {
    if (values.length > 0) {
      setRestaurantShippingCost(prev => {
        const updated = [...prev];
        if (updated.length > 0) {
          updated[0] = { ...updated[0], restaurantIds: values };
        }
        return updated;
      });
    }
  };

  const handlePriority = (value, activeKey) => {
    const parsedValue = parseInt(value);

    setRestaurantShippingCost(prev => {
      return prev.map(item => {
        if (item.key === activeKey) {
          return { ...item, priority: parsedValue };
        }
        return item;
      });
    });
  };
  

  const fetchProducts = async (values, merge = false) => {
    setLoading(true);
    try {
      let data = await getCatalogsAndOrdersData();
      let catEnable = data?.catalogs || [];
      let searchFilterQuery = '';
      let searchText = values;

      if (searchText) {
        const trimmed = String(searchText).trim();
        const isNumeric = /^\d+$/.test(trimmed);

        let firstFilterQuery = `&filter=state eq A&filter=channel eq APP&filter=or.channel eq WEB`;
        if (isNumeric) {
          if (!isNaN(trimmed, 10)) {
            searchFilterQuery += `&filter=or.id eq ${trimmed}` + firstFilterQuery;
          }
          if (!isNaN(trimmed, 10)) {
            searchFilterQuery += `&filter=or.classCode eq ${trimmed}` + firstFilterQuery;
          }

          if (!isNaN(trimmed, 10)) {
            searchFilterQuery += `&filter=or.productCode eq ${trimmed}` + firstFilterQuery;
          }
          if (!isNaN(trimmed, 10)) {
            searchFilterQuery += `&filter=or.sku eq ${trimmed}` + firstFilterQuery;
          }
        } else {
          searchFilterQuery += `&filter=or.name iLike %25${trimmed}%25` + firstFilterQuery;
        }
      }

      const res = await getItemsList({
        offset: state.offset,
        limit: state.limit,
        filter: `${searchFilterQuery}`,
        sort: `name asc`,
      }).unwrap();
      let items = res?.rows || [];

      items = items.filter(item => catEnable.find(cat => cat.id === item.classCode));

      items = items.map(item => {
        const orders = data?.catalogs.find(cat => cat.id === item.classCode)?.orders;
        let startTime = dayjs(orders?.startTime, 'HH:mm');
        let endTime = dayjs(orders?.endTime, 'HH:mm');
        const dayPart = getDayPart(endTime.hour()) || getDayPart(startTime.hour());
        return {
          ...item,
          orders,
          dayPart,
        };
      });

      setOptions(prev => {
        if (merge) {
          const map = new Map();
          prev.forEach(p => map.set(p.id, p));
          items.forEach(p => map.set(p.id, p));
          return Array.from(map.values());
        }
        return items || [];
      });
    } catch (error) {
      console.error('Error fetching product:', error);
    } finally {
      setLoading(false);
    }
  }

  


  const handleSearch = debounce(value => {
    if (value) {
      fetchProducts(value, false);
    } else {
      setOptions([]);
    }
  }, 500);

  const handleChange = async (values, activeKey) => {
    if (values === undefined) return;

    let item = options.find(o => o.id === values);
    if (!item) {
      item = await getSingleItem({ id: values }).unwrap();
    }
    const parsedValue = parseInt(item.id);

    setRestaurantShippingCost(prev => {
      return prev.map(p => {
        if (p.key === activeKey) {
          return { ...p, productId: parsedValue };
        }
        return p;
      });
    });
  };

  const getRestaurantListData = async () => {
    try {
      const res = await getRestaurantList({
        filter: `&filter=state eq A`,
      }).unwrap();
      dispatch(setRestaurantList({ list: res }));
    } catch (e) {
      if (!isMounted.current) return;
      console.log(e);
    }
  };

  const getShippingCostListData = async () => {
    try {
      const res = await getShippingCostList({}).unwrap();
      dispatch(setShippingCostList({ list: res }));
    } catch (e) {
      console.log(e);
    }
  };

  const getCatalogsAndOrdersData = async () => {
    try {
      const [catRes, catOrdersRes] = await Promise.all([getCatalogs({}).unwrap(), getCatalogOrder({}).unwrap()]);

      const catalogs = catRes?.rows || [];
      const catalogOrders = catOrdersRes?.rows || [];

      const filteredCatalogs = catalogs?.filter(catalog => catalog.state === 'A') || [];

      const activeCatalogs = filteredCatalogs.filter(
        item => item.state === 'A' && ['APP', 'WEB'].includes(item.channel),
      );

      const merged = activeCatalogs.map(catalog => {
        const order = catalogOrders.find(o => o.scid === catalog.superClassCode);
        return { ...catalog, orders: order };
      });

      return { catalogs: merged };
    } catch (e) {
      console.log(e);
      return null;
    }
  };

  const fetchMultipleProducts = async productIds => {
    if (!productIds || productIds.length === 0) return;
    setLoading(true);
    try {
      let data = await getCatalogsAndOrdersData();
      let catEnable = data?.catalogs || [];
      const uniqueIds = [...new Set(productIds)];
      let filterQuery = '';
      uniqueIds.forEach(id => {
        filterQuery += `&filter=or.id eq ${id}`;
      });
      filterQuery += `&filter=state eq A&filter=channel eq APP&filter=or.channel eq WEB`;

      const res = await getItemsList({
        offset: 0,
        limit: 100,
        filter: filterQuery,
        sort: `name asc`,
      }).unwrap();

      let items = res?.rows || [];
      items = items.filter(item => catEnable.find(cat => cat.id === item.classCode));
      items = items.map(item => {
        const orders = data?.catalogs.find(cat => cat.id === item.classCode)?.orders;
        let startTime = dayjs(orders?.startTime, 'HH:mm');
        let endTime = dayjs(orders?.endTime, 'HH:mm');
        const dayPart = getDayPart(endTime.hour()) || getDayPart(startTime.hour());
        return {
          ...item,
          orders,
          dayPart,
        };
      });

      setLoading(false);
      setOptions(items);
    } catch (e) {
      console.error(e);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    isMounted.current = true;
    getRestaurantListData();
    getShippingCostListData();

    const { id } = state;
    if (id) {
      getShippingCost({ id: id })
        .unwrap()
        .then(res => {
          if (!isMounted.current) return;
          dispatch(setShippingCost({ shippingCost: res }));

          const existingConfig = res?.RestaurantShippingCost || [];
          setCreateShippingCost(false);

          if (existingConfig.length > 0) {
            const productIds = existingConfig.map(i => i.productId).filter(Boolean);
            fetchMultipleProducts(productIds);

            const tabs = existingConfig.map((item, index) => {
              const key = generateKey() + index;
              return {
                label: `${intl.formatMessage({ id: 'Product' })} ${index + 1}`,
                key: key,
                children: intl.formatMessage({ id: 'Add item details' }),
                initialData: item,
              };
            });

            const stateItems = tabs.map(t => ({
              ...t.initialData,
              key: t.key,
            }));

            setRestaurantShippingCost(stateItems);
            setTabItem(tabs.map(({ initialData, ...rest }) => rest));
            setActiveKey(tabs[0].key);
          } else {
            const key = generateKey();
            setRestaurantShippingCost([{ ...INITIAL_SHIPPING_COST_ITEM, key }]);
          }
        })
        .catch(e => {
          console.error(e);
          if (!isMounted.current) return;
          setState(prev => ({ ...prev, isLoading: false }));
          history.push('/dashboard/shippingcost/new');
        });
    } else {
      setCreateShippingCost(true);
      dispatch(setShippingCost({ shippingCost: null }));
      const key = generateKey();
      setRestaurantShippingCost([{ ...INITIAL_SHIPPING_COST_ITEM, key }]);
      setTabItem([
        {
          label: intl.formatMessage({ id: 'Product' }) + ' 1',
          key: key,
          children: intl.formatMessage({ id: 'Add item details' }),
        },
      ]);
      setActiveKey(key);
    }

    return () => {
      isMounted.current = false;
    };
  }, []);

  const removeRestaurantManually = restaurantIdToRemove => {
    if (restaurantShippingCost.length > 0) {
      let updatedIds = restaurantShippingCost[0].restaurantIds.filter(id => !restaurantIdToRemove.includes(id));
      form.setFieldsValue({
        restaurant: updatedIds,
      });
      if (isAllSelected) {
        setIsAllSelected(false);
      }
      handleSearchRestaurant(updatedIds);
    }
  };

  const handleSubmit = e => {
    e.preventDefault();
    const { id } = state;
    form.validateFieldsAndScroll(async (err, values) => {
      let validItems = restaurantShippingCost.filter(item => item.productId !== null && item.priority !== null);

      if (err) {
        toast.error({
          title: intl.formatMessage({
            id: 'The field must not be empty!',
          }),
        });
        return;
      }

      const mealType = convertToDayJsTime(values.startTimeAt) + ',' + convertToDayJsTime(values.endTimeAt);

      const checkDuplicatePriority = () => {
        let validItems = restaurantShippingCost.filter(item => item.productId !== null && item.priority !== null);

        const priorities = validItems.map(item => item.priority);
        const uniquePriorities = new Set(priorities);

        return priorities.length !== uniquePriorities.size;
      };

      const checkDuplicateProduct = () => {
        let validItems = restaurantShippingCost.filter(item => item.productId !== null && item.priority !== null);
        const productIds = validItems.map(item => item.productId);
        const uniqueProductIds = new Set(productIds);

        return productIds.length !== uniqueProductIds.size;
      };

      const checkDuplicateRestaurantIds = (mealType, currentShippingCostId = null) => {
        const shippingCostsWithSameMealType = list?.shippingCosts?.filter(item => {
          let itemMealType = mealType.split(',');
          let startTime = itemMealType[0];
          let endTime = itemMealType[1];
          return startTime <= item.closeTime && endTime >= item.openTime;
        });

        let existingRestaurantIds = new Set();
        let existingLastModified = new Set();

        (shippingCostsWithSameMealType || []).forEach(item => {
          if (item.id != shippingCostInfo?.id) {
            const costItems = item.RestaurantShippingCost || [];
            costItems.forEach(costItem => {
              const rids = costItem.restaurantIds || [];
              rids.forEach(rid => existingLastModified.add(rid));
            });
          }
        });

        for (const existingShippingCost of shippingCostsWithSameMealType || []) {
          const existingItems = existingShippingCost.RestaurantShippingCost || [];
          for (const existingItem of existingItems) {
            const rids = existingItem.restaurantIds || [];
            if (currentShippingCostId === null) {
              rids.forEach(rid => existingRestaurantIds.add(rid));
            }
          }
        }

        if (currentShippingCostId !== null && shippingCostInfo?.RestaurantShippingCost) {
          const currentRecordItems = shippingCostInfo.RestaurantShippingCost || [];
          if (parseInt(shippingCostInfo?.id) === parseInt(currentShippingCostId)) {
            if (currentRecordItems.length > 0) {
              currentRecordItems[0].restaurantIds.forEach(rid => existingRestaurantIds.add(rid));
            }
          }
        }

        if (currentShippingCostId !== null) {
          const validItem0 = validItems.find(item => item.productId !== null && item.priority !== null);

          if (validItem0) {
            const checkExistingLastModified = (validItem0.restaurantIds || []).filter(item => {
              return !existingRestaurantIds.has(item) && existingLastModified.has(item);
            });
            if (checkExistingLastModified.length > 0) {
              removeRestaurantManually(checkExistingLastModified);
              return { isValid: false, hasDuplicates: true };
            }
          }

          const filteredValidItems = validItems
            .filter(item => item.productId !== null && item.priority !== null)
            .map(item => {
              const existingRids = (item.restaurantIds || []).filter(
                rid => existingRestaurantIds.has(rid) && !existingLastModified.has(rid),
              );

              const newRids = (item.restaurantIds || []).filter(rid => !existingLastModified.has(rid));

              const concatenatedRestaurantIds = [...new Set([...newRids, ...existingRids])];

              return {
                ...item,
                restaurantIds: concatenatedRestaurantIds,
              };
            });

          return { isValid: true, validItems: filteredValidItems };
        }

        for (const item of restaurantShippingCost) {
          if (item.restaurantIds?.length > 0) {
            for (const currentRid of item.restaurantIds) {
              if (existingRestaurantIds.has(currentRid)) {
                const checkExistingLastModified = (item.restaurantIds || []).filter(item => {
                  return existingRestaurantIds.has(item);
                });
                removeRestaurantManually(checkExistingLastModified);
                return { isValid: false, hasDuplicates: true };
              }
            }
          }
        }

        return { isValid: true, hasDuplicates: false };
      };

      if (checkDuplicatePriority()) {
        toast.error({
          title: intl.formatMessage({
            id: 'DupPrioritiesNotAllowed',
          }),
        });
        return;
      }

      if (checkDuplicateProduct()) {
        toast.error({
          title: intl.formatMessage({
            id: 'DupProdsNotAllowed',
          }),
        });
        return;
      }

      const currentShippingCostId = isCreateShippingCost ? null : id;
      const restaurantValidation = checkDuplicateRestaurantIds(mealType, currentShippingCostId);

      if (currentShippingCostId !== null && restaurantValidation.validItems) {
        validItems = restaurantValidation.validItems;
      }

      if (!restaurantValidation.isValid && restaurantValidation.hasDuplicates) {
        toast.error({
          title: intl.formatMessage({
            id: 'SameRestMultProducts',
          }),
        });
        return;
      }

      let payload = {
        openTime: convertToDayJsTime(values.startTimeAt),
        closeTime: convertToDayJsTime(values.endTimeAt),
        minimalShippingCost: parseInt(values.minimumAmount * 100),
        startDate: dayjs(new Date()).format('YYYY-MM-DD'),
        endDate: dayjs(new Date()).format('YYYY-MM-DD'),
        isAvailable: shippingCostInfo?.isAvailable ?? true,
        state: 'A',
      };

      if (validItems.length > 0) {
        let restaurantids = validItems?.filter(item => item.restaurantIds.length > 0);
        validItems.forEach(item => {
          if (item?.product !== undefined && item?.restaurant !== undefined) {
            delete item?.product;
            delete item?.restaurant;
          }
          item.restaurantIds = restaurantids[0]?.restaurantIds || [];
        });
        payload.restaurantShippingCost = validItems;
      }

      if (isCreateShippingCost) {
        try {
          await createShippingCost(payload).unwrap();
          toast.success({
            title: intl.formatMessage({
              id: 'Shipping cost is created successfully',
            }),
          });
          cleanForm();
        } catch (e) {
          setState(prev => ({ ...prev, isLoading: false }));
          toast.error({
            title: intl.formatMessage({
              id: 'Shipping cost creation is failure',
            }),
          });
        }
      } else {
        try {
          await updateShippingCost({ id: id, shippingCost: payload }).unwrap();
          toast.success({
            title: intl.formatMessage({
              id: 'Shipping cost is updated successfully',
            }),
          });
          cleanForm();
        } catch (e) {
          console.log('error', e);
          setState(prev => ({ ...prev, isLoading: false }));
          toast.error({
            title: intl.formatMessage({
              id: 'Updating shipping cost is failure',
            }),
          });
        }
      }
    });
  };

  const cleanForm = () => {
    setCreateShippingCost(true);
    dispatch(setShippingCost({ shippingCost: null }));
    history.push('/dashboard/shippingcost');
  };

  const typeToTranslate = type => {
    try {
      let split = type.split('-');
      return split.map(part => intl.formatMessage({ id: part })).join(' - ');
    } catch {
      return '';
    }
  };

  return (
    <div className="shippingCost_new_layout">
      <ContentHeader type="shippingcost_new" isEdit={!isCreateShippingCost} onCreateShippingCost={handleSubmit} />
      <div className="main_content">
        <div className="shippingCost_info_wrapper">
          <Form className="form-container">
            <div className="form-container-restaurants">
              <h3 className="form-title">
                <FormattedMessage id="Where will they be shown" />
              </h3>
              <Divider />
              <div className="form-select-restaurants">
                <Form.Item>
                  <div className="selection-header">
                    <Checkbox checked={isAllSelected} onChange={e => handleAllSelectedRestaurant(e.target.checked)}>
                      <FormattedMessage id="Select all" />
                    </Checkbox>

                    <div className="btn_clear_wrapper">
                      <Button className="btn_clear" onClick={clearRestaurant}>
                        <FormattedMessage id="Clear selection" />
                        <ClearOutlined />
                      </Button>
                    </div>
                  </div>

                  {getFieldDecorator('restaurant', {
                    rules: [
                      {
                        required: true,
                        message: intl.formatMessage({
                          id: 'Select restaurant is required!',
                        }),
                      },
                    ],
                    initialValue:
                      shippingCostInfo?.RestaurantShippingCost &&
                      Array.isArray(shippingCostInfo?.RestaurantShippingCost)
                        ? shippingCostInfo?.RestaurantShippingCost[0]?.restaurantIds
                        : [],
                  })(
                    <Select
                      showSearch
                      mode="multiple"
                      placeholder={intl.formatMessage({ id: 'Select restaurant' })}
                      onChange={e => handleSearchRestaurant(e)}
                      filterOption={(input, option) => option.children.toLowerCase().includes(input.toLowerCase())}
                      getPopupContainer={trigger => trigger.parentNode}
                    >
                      {restaurantList?.rows.map(item => (
                        <Option value={item.id} key={item.id}>
                          {item.description}
                        </Option>
                      ))}
                    </Select>,
                  )}
                </Form.Item>
              </div>
            </div>
            <div className="form-container-items">
              <h3 className="form-title">
                <FormattedMessage id="What elements will be shown" />
              </h3>
              <Divider />
              <div className="tabs-container">
                <div className="tabs_picker_wrapper" style={{ height: 'auto', overflow: 'auto' }}>
                  <Tabs activeKey={`${activeKey}`} onChange={onChangeTab} className="shipping_cost_new_tabs">
                    {tabItem.map(item => (
                      <TabPane tab={item.label} key={`${item.key}`}>
                        <p className="title">{item.children}</p>
                      </TabPane>
                    ))}
                  </Tabs>

                  <div className="button_picker_wrapper">
                    <Button onClick={() => handleAppendTab(intl.formatMessage({ id: 'Product' }))}>
                      <Add />
                    </Button>
                    <Button onClick={() => handleRemoveTab(activeKey)}>
                      <Delete />
                    </Button>
                  </div>
                </div>
              </div>
              <div className="select_picker_wrapper">
                {tabItem.map(item => (
                  <div
                    key={item.key}
                    style={{ display: item.key === activeKey ? 'flex' : 'none' }}
                    className="select_picker_wrapper__item"
                  >
                    <Form.Item>
                      <p className="title">
                        <FormattedMessage id="priority" />
                      </p>
                      {getFieldDecorator(`priority_${item.key}`, {
                        rules: [
                          {
                            required: true,
                            message: intl.formatMessage({
                              id: 'Priority is required!',
                            }),
                          },
                        ],
                        initialValue: restaurantShippingCost.find(r => r.key === item.key)?.priority || null,
                      })(
                        <Select
                          placeholder={intl.formatMessage({ id: 'select priority' })}
                          dropdownStyle={{ paddingLeft: '0', paddingRight: '0' }}
                          style={{ width: '100%' }}
                          onChange={e => handlePriority(e, activeKey)}
                          getPopupContainer={trigger => trigger.parentNode}
                        >
                          {priorityState.map(priority => (
                            <Option key={priority.label} value={priority.value}>
                              {priority.label}
                            </Option>
                          ))}
                        </Select>,
                      )}
                    </Form.Item>

                    <Form.Item>
                      <p className="title">
                        <FormattedMessage id="Product" />
                      </p>
                      {getFieldDecorator(`productCode${item.key}`, {
                        rules: [
                          {
                            required: true,
                            message: intl.formatMessage({
                              id: 'Product is required!',
                            }),
                          },
                        ],
                        initialValue: restaurantShippingCost.find(r => r.key === item.key)?.productId || null,
                      })(
                        <Select
                          showSearch
                          allowClear
                          placeholder={intl.formatMessage({ id: 'Select product' })}
                          dropdownStyle={{ paddingLeft: 0, paddingRight: 0 }}
                          onSearch={handleSearch}
                          onChange={e => handleChange(e, activeKey)}
                          notFoundContent={loading ? <Spin size="small" /> : null}
                          filterOption={false}
                          style={{ width: '100%' }}
                        >
                          {options.map(item => {
                            const codeImage =
                              item?.productCode > 0 ? item?.productCode : getProduct(item).productCode || item.sku;

                            const src =
                              codeImage !== undefined
                                ? `${process.env.REACT_APP_S3}/${item?.channel === 'APP' ? 'customer' : 'ots'}/${
                                    item?.productCode > 0 ? item?.productCode : getProduct(item).productCode || item.sku
                                  }.jpg`
                                : placeHolderImg;

                            return (
                              <Option key={item.id} value={item.id}>
                                <div
                                  style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '8px',
                                    overflow: 'auto',
                                  }}
                                >
                                  <img
                                    src={errorMap[item.id] ? placeHolderImg : src}
                                    alt={item.name}
                                    style={{ width: 40, height: 40 }}
                                    onError={() => setErrorMap(prev => ({ ...prev, [item.id]: true }))}
                                  />
                                  <div style={{ display: 'flex' }}>
                                    ID: {item.id}, SKU: {item.sku}
                                  </div>{' '}
                                  - <span dangerouslySetInnerHTML={{ __html: item.name }} />
                                  &nbsp;{getCurrency().symbol}
                                  {(item.price / 100).toFixed(2)}
                                  &nbsp;&nbsp;
                                  {typeToTranslate(item?.dayPart)}
                                </div>
                              </Option>
                            );
                          })}
                        </Select>,
                      )}
                    </Form.Item>
                  </div>
                ))}
              </div>
            </div>

            <div className="form-container-rules">
              <h3 className="form-title">
                <FormattedMessage id="Rules" />
              </h3>
              <Divider />
              <div className="rules-grid">
                <div className="timesheet_wrapper">
                  <div className="time_picker_wrapper">
                    <Form.Item>
                      <p className="title">
                        <FormattedMessage id="start_time" />
                      </p>
                      {getFieldDecorator('startTimeAt', {
                        rules: [
                          {
                            required: true,
                            message: intl.formatMessage({
                              id: 'Start time is required!',
                            }),
                          },
                        ],

                        initialValue: shippingCostInfo?.openTime ? dayjs(shippingCostInfo?.openTime, 'HH:mm') : null,
                      })(
                        <TimePicker
                          className="form-date"
                          format="HH:mm"
                          inputReadOnly
                          getPopupContainer={trigger => trigger.parentNode}
                          placeholder={intl.formatMessage({ id: 'Select time' })}
                        />,
                      )}
                    </Form.Item>
                    <Form.Item>
                      <p className="title">
                        <FormattedMessage id="Finish time" />
                      </p>
                      {getFieldDecorator('endTimeAt', {
                        rules: [
                          {
                            required: true,
                            message: intl.formatMessage({
                              id: 'Finish time is required!',
                            }),
                          },
                        ],
                        initialValue: shippingCostInfo?.closeTime ? dayjs(shippingCostInfo?.closeTime, 'HH:mm') : null,
                      })(
                        <TimePicker
                          className="form-date"
                          inputReadOnly
                          format="HH:mm"
                          placeholder={intl.formatMessage({ id: 'Select time' })}
                        />,
                      )}
                    </Form.Item>
                  </div>
                </div>
              </div>
              <div className="rules-input_select__wrapper">
                <Form.Item>
                  <p className="title">
                    <FormattedMessage id="Minimum amount" /> {getCurrency().symbol}
                  </p>
                  {getFieldDecorator('minimumAmount', {
                    rules: [
                      {
                        required: true,
                        message: intl.formatMessage({
                          id: 'MinimumAmount is required!',
                        }),
                      },
                    ],
                    initialValue: shippingCostInfo?.minimalShippingCost
                      ? shippingCostInfo?.minimalShippingCost / 100
                      : null,
                  })(<Input placeholder="0.00" type="number" />)}
                </Form.Item>
              </div>
            </div>
          </Form>
        </div>
      </div>
    </div>
  );
};

ShippingCostNew.defaultProps = {
  form: {},
};

export default compose(injectIntl, Form.create({ name: 'shippingCost_form' }))(ShippingCostNew);
